import React from 'react'

import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'

import Icon from './Icon'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
  },
  icon: {
    marginRight: theme.spacing(),
    color: theme.palette.text.hint,
  },
  boldText: {
    fontWeight: 'bold',
  },
}))

const IconTitle = ({
  className,
  type,
  title,
  textVariant,
  textClassname,
  UseIcon,
  bold,
  onClick,
  children,
}) => {
  const classes = useStyles()

  return (
    <div 
      className={ `${classes.root} ${className || ''}` }
      onClick={ onClick }
    >
      {
        UseIcon ? (
          <UseIcon 
            className={ classes.icon }
          />
        ) : (
          <Icon
            className={ classes.icon }
            type={ type }
          />
        )
      }
      {
        children ? children : (
          <Typography 
            variant={ textVariant }
            className={ `${textClassname} ${ bold ? classes.boldText : '' }` }
          >
            { title }
          </Typography>
        )
      }
    </div>
  )
}

IconTitle.defaultProps = {
  textVariant: 'body1',
}

export default IconTitle

